import { useEffect, useState, useCallback } from "react";
import { useEgresoINMOB } from "../../Services/Inmobiliaria/Egresos";

export const useEgresoTodosINMOB = () => {
  const { 
      getEgresos,
      getCategoriaEgresos, 
      getProveedorInmobiliaria,
      getfiltromeses,
      getfiltromesesyaño
  } = useEgresoINMOB();
  const [egresosInmob, setEgresosInmob] = useState([]);
  const [errorEgresosInmob, setErrorEgresosInmob] = useState(null);
  const [loadingEgresosInmob, setLoadingEgresosInmob] = useState(true);

  /* categoria */
  const [egresosCategoriaInmob, setEgresosCategoriaInmob] = useState([]);
  const [errorEgresosCategoriaInmob, setErrorEgresosCategoriaInmob] = useState(null);
  const [loadingEgresosCategoriaInmob, setLoadingEgresosCategoriaInmob] = useState(true);

  /* proveedor */

  const [ProveedorInmob, setProveedorInmob] = useState([]);
  const [errorProveedorInmob, setErrorProveedorInmob] = useState(null);
  const [loadingProveedorInmob, setLoadingProveedorInmob] = useState(true);

  const [meses, setMeses] = useState([]);
const [Egresos, setEgresos] = useState(null);
const [mesSeleccionado, setMesSeleccionado] = useState("");
const [anioSeleccionado, setAnioSeleccionado] = useState("");
const [loadingMeses, setLoadingMeses] = useState(true);

  const fetchEgresoINMOB = useCallback(async () => {
    setLoadingEgresosInmob(true);
    try {
      const data = await getEgresos();
      setEgresosInmob(data);
    } catch (error) {
      setErrorEgresosInmob(error?.message || "Error al obtener deudores");
    } finally {
      setLoadingEgresosInmob(false);
    }
  }, []);

  const fetchEgresoCategoriaINMOB = useCallback(async () => {
    setLoadingEgresosCategoriaInmob(true);
    try {
      const data = await getCategoriaEgresos();
      setEgresosCategoriaInmob(data);
    } catch (error) {
      setErrorEgresosCategoriaInmob(error?.message || "Error al obtener deudores");
    } finally {
      setLoadingEgresosCategoriaInmob(false);
    }
  }, []);

  /* proveedor */
  const fetchProveedor = useCallback(async () => {
   setLoadingProveedorInmob(true);
    try {
      const data = await getProveedorInmobiliaria();
      setProveedorInmob(data?.data ?? data);
    } catch (error) {
      setErrorProveedorInmob(error?.message);
    } finally {
      setLoadingProveedorInmob(false);
    }
  }, []);
  
   const fetchMeses = useCallback(async () => {
  setLoadingMeses(true);
  try {
    const data = await getfiltromeses();
    setMeses(data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoadingMeses(false);
  }
}, [getfiltromeses]);


  useEffect(() => {
    fetchEgresoINMOB();
    fetchEgresoCategoriaINMOB();
    fetchProveedor();
    fetchMeses();
  }, [fetchEgresoINMOB, fetchEgresoCategoriaINMOB, fetchProveedor, fetchMeses]);






  return {
    egresosInmob,
    errorEgresosInmob,
    loadingEgresosInmob,
    egresosCategoriaInmob,
    errorEgresosCategoriaInmob,
    loadingEgresosCategoriaInmob,
    refetchEgresoINMOB: fetchEgresoINMOB,
    refetchEgresoCategoriaINMOB: fetchEgresoCategoriaINMOB,
    /* proveedor */
    ProveedorInmob,
    loadingProveedorInmob,
    refetchEgresoProveedorINMOB: fetchProveedor,
    /* filtro */
    getfiltromesesyaño ,
    meses,
    loadingMeses,
    mesSeleccionado,
    setMesSeleccionado,
    anioSeleccionado,
    setAnioSeleccionado,
    Egresos,
    setEgresos
  };
}
